import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';

import { get } from '../../../lib/api';
import { selectCampaign } from '../../../lib/redux/selectedCampaign/selectedCampaignSlice';
import { trackCampaignView } from '../components/UserViewCampaigns/data/data';

const USER_VIEW_CAMPAIGNS = 'userViewCampaigns';

const updateUrl = campaignUUid => {
  const indexUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  const newCampaignUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?campaign_id=${campaignUUid}`;
  const newurl = campaignUUid ? newCampaignUrl : indexUrl;

  window.history.pushState({ path: newurl }, '', newurl);
};

export const useGetUserViewCampaigns = ({ campaignUUid }) => {
  const dispatch = useDispatch();
  const selectedCampaignUuid = useSelector(
    state => state.selectedCampaign.uuid,
  );

  const setSelectedCampaign = campaign => {
    updateUrl(campaign.uuid);
    dispatch(selectCampaign(campaign));

    if (campaign.uuid) {
      trackCampaignView({ campaignUuid: campaign.uuid });
    }
  };

  const setInitialCampaign = data => {
    const selectedCampaign = data.campaigns.find(
      campaign => campaign.uuid === campaignUUid,
    );

    if (selectedCampaign) {
      setSelectedCampaign(selectedCampaign);
    }
  };

  const {
    data: { campaigns },
    isFetching,
  } = useQuery([USER_VIEW_CAMPAIGNS], () => get('/api/v1/campaigns'), {
    refetchOnWindowFocus: false,
    initialData: {
      campaigns: [],
    },
    onSuccess: data => setInitialCampaign(data),
  });

  return {
    campaigns,
    selectedCampaignUuid,
    setSelectedCampaign,
    isFetching,
  };
};
